{
  "startne": {
    "main": {
      "title": "Camo pregledi - Štartne liste",
      "titleMotorna": "Motorna",
      "titleJadralna": "Jadralna",
      "titleUltralight": "Ultralight"
    },
    "buttons": {
      "nazaj": "Nazaj",
      "nazajGlavni": "Glavni meni",
      "natisni": "Natisni ",
      "poslji": "Pošlji ",
      "brisiIzbiro": "Briši izbiro"
    },
    "nav": {
      "jadralna": "Camo pregledi - Štartne liste jadralnih",
      "motorna": "Camo pregledi - Štartne liste motornih",
      "ultralight": "Camo pregledi - Štartne liste ultralight"
    },
    "labels": {
      "datumOd": "Datum OD :",
      "datumDo": "Datum DO :",
      "klubL": "Izberi klub letala:",
      "klubP": "Izberi klub pilota:",
      "namen": "Izberi namen:",
      "naloga": "Izberi nalogo:",
      "pilot": "Izberi pilota:",
      "reg": "Izberi reg. letala:",
      "stPristankov": "Št. pristankov: ",
      "stLetov": "Št. letov: ",
      "casVZraku": "Čas v zraku: "
    },
    "data": {
      "title": "Podatki",
      "stPristankov": "Št. pristankov:",
      "stLetov": "Št. letov:",
      "casVZraku": "Trajanje:"
    },
    "table": {
      "reg": "REG",
      "vzlet": "VZLET",
      "pilot": "PILOT",
      "trajanje": "TRAJANJE",
      "naloga": "NALOGA",
      "datum": "DATUM",
      "odklop": "ODKLOP",
      "pristanek": "PRISTANEK",
      "titleM": "MOTORNI LETI",
      "titleJ": "JADRALNI LETI",
      "titleU": "ULTRALIGHT LETI"
    }
  }
}